<template>
  <button v-bind="$attrs" :disabled="disabled" class="btn" :class="[classes]" :type="type">
    <slot />
  </button>
</template>

<script setup>
import { computed } from 'vue';


const props = defineProps({
  variants: {
    type: String,
    default: 'primary',
    validator: value =>
      [
        'primary',
        'transparent',
        'light'
      ].includes(value)
  },
  size: {
    type: String,
    validator: value => ['xsmall', 'small', 'medium', 'large'].includes(value)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'button'
  }
})

const classes = computed(() => {
  const variant = props.variants ? `btn-${props.variants}` : '';
  const size = props.size ? `btn-${props.size}` : '';
  const disabled = props.disabled ? `btn-disabled` : '';
  return `${variant} ${size} ${disabled}`;
})

</script>
<script>
export default {
  inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
button {
  border: none;
  outline: none;
  background: none;
}

.btn {
  @apply outline-none border-none transition-all duration-150 ease-linear rounded-4xl flex items-center justify-center font-medium;

  &-primary {
    @apply bg-secondary text-white;
  }

  &-transparent {
    @apply bg-[#FFF0EF] text-secondary;
  }

  &-light {
    @apply bg-white text-secondary shadow-sm;
  }

  &-xsmall {
    @apply h-8 text-[14px];
  }

  &-small {
    @apply h-11 text-[14px];
  }

  &-medium {
    @apply h-12;
  }

  &-large {
    @apply h-16;
  }

  &-disabled {
    @apply bg-[#FFF0EF] text-[#F5D5D2];
  }
}
</style>